import { PublicKey } from "@solana/web3.js";

import { Plaque } from "./Plaque";
import type { KothRoundState } from "./useKothRound";

interface KingNameplateProps {
  round: KothRoundState | null;
  localWalletPubkey: PublicKey | null;
  position: [number, number, number];
  rotation?: [number, number, number];
}

export function KingNameplate({
  round,
  localWalletPubkey,
  position,
  rotation,
}: KingNameplateProps): JSX.Element {
  const hasKing =
    !!round && !round.currentKing.equals(PublicKey.default) && round.status === 0;
  const isYouKing =
    hasKing && !!localWalletPubkey && round!.currentKing.equals(localWalletPubkey);
  const label = !hasKing ? "NONE" : isYouKing ? "YOU" : shortPk(round!.currentKing);

  return (
    <Plaque
      position={position}
      rotation={rotation}
      width={3.2}
      height={1.4}
      backerColor="#3a2a18"
      title="👑 KING"
      titleColor={isYouKing ? "#ffd66b" : "#f4d36a"}
      titleSize={0.32}
      lines={[label]}
      bodyColor={isYouKing ? "#ffd66b" : "#e8e8ef"}
      bodySize={0.32}
    />
  );
}

function shortPk(pk: PublicKey): string {
  const s = pk.toBase58();
  return `${s.slice(0, 4)}…${s.slice(-4)}`;
}
